var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-switch",class:{'is-checked': _vm.value},on:{"click":_vm.handleClick}},[_c('input',{ref:"input",staticClass:"re-switch__input",attrs:{"type":"checkbox","name":_vm.name}}),_c('span',{ref:"core",staticClass:"re-switch__core"},[_c('span',{staticClass:"re-switch__button"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }